<template>
	<div class="page">
		<div class="container-fluid">
			<div style="display: flex;align-items: flex-end;">
				<span style="font-size: 20px;color:#fff">{{formatType(type).title}}</span>
			</div>
			<span style="margin-top: 10px;font-size: 14px;color:#fff">{{formatType(type).value}}</span>
			<div class="inner-btn" @click="changeType">
				{{type=='list'?'添加代理':'返 回'}}
			</div>
		</div>
		<AgentList ref="list" v-if="type==='list'" @toEdit="toEdit"></AgentList>
		<AddAgent v-if="type==='add'" @back="back"></AddAgent>
		<EditAgent v-if="type==='edit'" @back="back" :agent_software_id="agent_software_id"></EditAgent>
		<!-- <ListCard ref="list" v-if="type==='list'" @toEdit="toEdit"></ListCard>
		
		 -->
	</div>
</template>

<script>
	import AgentList from '../../components/agent/AgentList.vue'
	import AddAgent from '../../components/agent/AddAgent.vue'
	import EditAgent from '../../components/agent/EditAgent.vue'
	let types = {
		list:{
			title:'代理列表',
			value:'agent list'
		},
		add:{
			title:'添加代理',
			value:'agent card'
		},
		edit:{
			title:'修改代理',
			value:'agent card'
		}
	}
	export default {
		components:{
			AgentList,
			AddAgent,
			EditAgent
		},
		data() {
			return {
				type:'list',
				agent_software_id:null
			}
		},
	
		methods:{
			formatType(value){
				return types[value]
			},
			changeType(){
				if(this.type==='add'||this.type==='edit'){
					this.type ='list'
				}else{
					this.type = 'add'
				}
				console.log(this.type)
			},
			back(){
				this.type = 'list'
				setTimeout(()=>{
					this.$refs.list.search()
				},500)
				
			},
			toEdit(agent_software_id){
				this.agent_software_id = agent_software_id
				this.type = 'edit'
			}
		}
	}
</script>

<style>
	.page {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		flex-direction: column;
	}

	.page .container-fluid {
		padding: 45px 25px;
		display: flex;
		flex-direction: column;
		background-color: rgb(66, 75, 79);
		position: relative;
		color: #e6e6e6;
	}
	.page .container-fluid .inner-btn{
		width: 120px;
		height: 40px;
		border: 1px solid #ccc;
		position: absolute;
		top: 40px;
		right: 20px;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		cursor:pointer;
	}

</style>